module.exports = "/templates/bds/public/font/68a68036d1804de9dd28565a4b860933.woff2";